import { AdditiveBlending, Group, Sprite, SpriteMaterial, Vector3 } from 'three';
import { drawnTexture } from '../arena/canvasTexture';

const count = 5;
const radius = 0.24;
const above = 0.26;
const centre = new Vector3();

/** Cartoon stars circling a dazed head: they fade in while he reels or lies knocked out, and fade away after. */
export class DizzyStars {
  readonly group = new Group();
  private readonly stars: Sprite[] = [];
  private readonly material: SpriteMaterial;
  private shown = 0;
  private turn = 0;

  constructor() {
    const texture = drawnTexture(128, 128, (g, w, h) => {
      g.translate(w / 2, h / 2);
      g.beginPath();
      for (let i = 0; i < 10; i++) {
        const r = i % 2 === 0 ? w * 0.46 : w * 0.2;
        const a = (i / 10) * Math.PI * 2 - Math.PI / 2;
        g.lineTo(Math.cos(a) * r, Math.sin(a) * r);
      }
      g.closePath();
      g.fillStyle = '#ffe066';
      g.strokeStyle = '#fff6c8';
      g.lineWidth = 6;
      g.fill();
      g.stroke();
    });
    this.material = new SpriteMaterial({ map: texture, color: 0xffffff, transparent: true, depthWrite: false, blending: AdditiveBlending, opacity: 0 });
    for (let i = 0; i < count; i++) {
      const star = new Sprite(this.material);
      star.scale.setScalar(0.09);
      this.stars.push(star);
      this.group.add(star);
    }
    this.group.visible = false;
  }

  /** Circles the stars over this head while dazed is true. */
  update(seconds: number, head: Vector3, dazed: boolean): void {
    this.shown = Math.max(0, Math.min(1, this.shown + (dazed ? 4 : -2) * seconds));
    this.group.visible = this.shown > 0;
    if (!this.group.visible) return;
    this.turn += seconds * 4;
    this.material.opacity = this.shown;
    this.material.rotation = this.turn * 0.5;
    centre.copy(head).setY(head.y + above);
    this.stars.forEach((star, i) => {
      const a = this.turn + (i / count) * Math.PI * 2;
      star.position.set(centre.x + Math.cos(a) * radius, centre.y + Math.sin(a * 2) * 0.03, centre.z + Math.sin(a) * radius * 0.6);
    });
  }
}
